import type { FC, PropsWithChildren } from 'react';
import type { ViewProps } from 'react-native';
import { View } from 'react-native';

export const Row: FC<PropsWithChildren & ViewProps> = ({
  children,
  style,
  ...props
}) => (
  <View style={[{ flexDirection: 'row' }, style]} {...props}>
    {children}
  </View>
);
